import type { BookingRecord, TripStatus } from '../../../types'
import { BookingRow } from './BookingRow'
import { BOOKINGS_MIN_WIDTH } from './bookingsTableLayout'
import { BookingsTableHeader } from './BookingsTableHeader'
import type { RowAction } from '../../../components/ui/RowActionsMenu'
import { Download } from 'lucide-react'

type BookingsTableCardProps = {
  bookings: BookingRecord[]
  /** Shown next to the tab so the count reflects the active filters. */
  totalCount: number
  onTripStatusChange: (id: string, status: TripStatus) => void
  onAssignDriver: (id: string) => void
  buildRowActions: (booking: BookingRecord) => RowAction[]
  onToggleFilters?: () => void
  onExportExcel: () => void
  exportDisabled: boolean
}

export const BookingsTableCard = ({
  bookings,
  totalCount,
  onTripStatusChange,
  onAssignDriver,
  buildRowActions,
  onExportExcel,
  exportDisabled,
}: BookingsTableCardProps) => (
  <section className="w-full rounded-[18px] bg-white px-[10px] py-[19px] shadow-dash-table">
    <div className="flex items-end justify-between gap-[16px] px-[15px]">
      <h2 className="border-b-2 border-solid border-dash-tab-underline p-[10px] font-host text-[16px] font-medium leading-normal text-black">
        All Bookings
        <span className="sr-only"> ({totalCount})</span>
      </h2>

      <button
        type="button"
        onClick={onExportExcel}
        disabled={exportDisabled}
        className="flex items-center gap-[8px] rounded-[8px] border border-[#E5E5E5] px-[14px] py-[9px] font-host text-[14px] font-medium text-black transition-colors hover:bg-[#F7F7F7] disabled:cursor-not-allowed disabled:opacity-40"
      >
        <Download size={16} />
        Export Excel
      </button>
    </div>

    <div className="mt-[21px] max-h-[calc(100dvh-300px)] w-full overflow-auto rounded-[12px] bg-white p-[10px] pr-[4px]">
      <div
        className="flex flex-col gap-[11px]"
        style={{ minWidth: BOOKINGS_MIN_WIDTH }}
      >
        <BookingsTableHeader />

        {bookings.length === 0 ? (
          <p className="py-[40px] text-center font-host text-[16px] font-normal leading-normal text-dash-col-head">
            No bookings match the current filters.
          </p>
        ) : (
          bookings.map((booking) => (
            <BookingRow
              key={booking.id}
              actions={buildRowActions(booking)}
              booking={booking}
              onAssignDriver={onAssignDriver}
              onTripStatusChange={onTripStatusChange}
            />
          ))
        )}
      </div>
    </div>
  </section>
)